import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell } from 'lucide-react';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { useApp } from '../../context/AppContext';

function MainLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { currentUser } = useAuth();
  const { notifications, students, parents } = useApp();

  // Unread homework alerts for parent
  let unreadCount = 0;
  if (currentUser?.role === 'parent') {
    const parent = parents?.find(p => p.id === currentUser?.profileId);
    const child = students?.find(s => parent?.studentIds?.includes(s.id));
    unreadCount = (notifications || []).filter(n =>
      n.type === 'homework' && n.targetRoles.includes('parent') &&
      n.classId === child?.classId && !n.readBy.includes(currentUser?.id)
    ).length;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex w-64 flex-shrink-0 flex-col">
        <Sidebar />
      </div>
      {/* Mobile Sidebar */}
      {mobileSidebarOpen && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setMobileSidebarOpen(false)} />
          <Sidebar mobile onClose={() => setMobileSidebarOpen(false)} />
        </>
      )}
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <header className="bg-white border-b border-gray-200 px-4 flex items-center justify-between flex-shrink-0 h-16">
          <button className="lg:hidden p-1.5 rounded-lg hover:bg-gray-100" onClick={() => setMobileSidebarOpen(true)}>
            <Menu size={20} className="text-gray-600" />
          </button>
          <div className="hidden lg:block">
            <p className="">Academic Year 2025-2026</p>
          </div>
          <div className="flex items-center gap-3 ml-auto">
            <button className="relative p-2 rounded-lg hover:bg-gray-100">
              <Bell size={18} className="text-gray-600" />
              {unreadCount > 0
                ? <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 rounded-full text-white text-[10px] font-bold flex items-center justify-center px-1">{unreadCount}</span>
                : <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              }
            </button>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold">
                {currentUser?.name?.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)}
              </div>
              <span className="hidden sm:block text-sm font-medium">{currentUser?.name}</span>
            </div>
          </div>
        </header>
        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
export default MainLayout;
